import React, { useState } from "react";
import DownSidePanel from "./downSidePanelContainer";
import styles from "./buttonWithDocumentPanel.module.css";
import escapeId from "Common/stringUtils/escapeId";
import { ButtonWithPopover } from "UiKit";
export default function ButtonWithDocumentPanel({ targetId }) {
    const [isOpen, setIsOpen] = useState(false);
    const onShowing = () => {
        setIsOpen(true);
    };
    const onHidden = () => {
        setIsOpen(false);
    };
    return (React.createElement(ButtonWithPopover, { popoverContent: React.createElement(DownSidePanel, null), popoverClassName: styles.popover, popoverHeight: "min(248px, 100%)", popoverWidth: "min(900px, 100%)", onHidden: onHidden, onShowing: onShowing, hideOnOutsideClick: true, ignoreHidingWhenChanged: true, position: targetId ? { of: `#${escapeId(targetId)}`, offset: { y: 8 } } : undefined, isActive: isOpen, styleType: "text", size: "32", iconOnly: true },
        React.createElement("i", { className: "icon-history" })));
}
